import React from 'react';

import { type CollectionColumnDefinition, type ColumnDefinition, ModelColumns } from '~/types/components';
import type { Role, User, UserGroup } from '~/types/models';

import { tc } from '~/helpers';

const roleUsersColumn: CollectionColumnDefinition<Role, User> = {
  title: 'Utilisateurs',
  key: 'users',
  only: ['single'],
  sortable: false,
  type: 'collection',
  render: (value) => {
    if (!Array.isArray(value)) {
      return '';
    }
    if (value.length === 0) {
      return <em>Aucun utilisateur</em>;
    }
    return (
      <ul style={{ margin: 0 }}>
        {value.map((u) => (
          <li key={u.id}>{u.name}</li>
        ))}
      </ul>
    );
  },
};
const roleUsersCountColumn: ColumnDefinition<Role> = {
  title: "Nb d'utilisateurs",
  key: 'usersCount',
  sortable: false,
  type: 'count',
  render: (count) => {
    return tc('{count} utilisateur|{count} utilisateurs', count);
  },
};
const roleUserGroupsColumn: CollectionColumnDefinition<Role, UserGroup> = {
  title: 'Permissions',
  key: 'userGroups',
  only: ['single'],
  sortable: false,
  type: 'collection',
  render: (value) => {
    if (!Array.isArray(value)) {
      return '';
    }
    if (value.length === 0) {
      return <em>Aucune permission</em>;
    }
    return (
      <ul style={{ margin: 0 }}>
        {value.map((u) => (
          <li key={u.id}>{u.group?.name}</li>
        ))}
      </ul>
    );
  },
};
export const Columns: Array<ColumnDefinition<Role>> = [
  {
    title: 'Nom',
    key: 'name',
    sortable: true,
    type: 'string',
  },
  {
    title: 'Description',
    key: 'description',
    sortable: false,
    type: 'string',
  },
  {
    title: 'Nom système',
    key: 'slug',
    sortable: true,
    type: 'string',
  },
  roleUsersColumn,
  roleUsersCountColumn,
  roleUserGroupsColumn,
  ...ModelColumns,
];
